















import Vue from "vue";
import { store } from "../services/store";
import ScrollDisplay from "./ScrollDisplay.vue";

export default Vue.extend({
  components: {
    ScrollDisplay
  },
  computed: {
    list() {
      return store.scrollDisplayList;
    }
  }
});
